/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

/**
 * Rounds the number to the precision.
 * @param {number} num
 * @param {number} precision
 * @returns {number}
 */
export function round (num, precision = 0) {
  return precision !== 0
    ? Math.round((num) * 10 ** precision) / 10 ** precision
    : Math.round(num)
}
